import React, { memo } from 'react';
import { Icon } from '@ann/web-components';
import { SELECT_LOCATION_COPY } from '../../constants/dashboardBuilderCopy';
import {
  BackButton,
  BackLabel,
  BreadcrumbText,
  NavBarContainer,
} from './NavigationBar.styled';

const NavigationBar = ({ breadcrumb = '', onBack }) => {
  return (
    <NavBarContainer>
      <BackButton type="button" onClick={onBack}>
        <Icon name="arrowLeft" size="small" color="neutral" />
        <BackLabel>{SELECT_LOCATION_COPY.backButton}</BackLabel>
      </BackButton>
      <BreadcrumbText>{breadcrumb}</BreadcrumbText>
    </NavBarContainer>
  );
};

export default memo(NavigationBar);
